import {Store} from "pullstate";


export const resetLoginViewStore = () => {
    LoginViewStore.update(s => {
        s.current = 0;
        s.active = 0;
        s.loading = false;
        s.loginMethod = 'member';
        s.member = null;
        s.email = null;
        s.inputValue = '';
        s.magicLink = false;
        s.nextDisabled = true;
        s.error = null;
        s.secureEmail = null;
        s.password = '';
        s.users = []
        s.selectUsers = false;
        s.selectUsersAction = () => { console.error('selectUsersAction not set')};
    })
}

export const LoginViewStore = new Store({
    current: 0,
    isCourse: false,
    active: 0,
    loading: false,
    loginMethod: 'member',
    member: null,
    email: null,
    inputValue: '',
    magicLink: false,
    nextDisabled: true,
    error: null,
    secureEmail: null,
    password: '',
    users: [],
    selectUsers: false,
    selectUsersAction: () => { console.error('selectUsersAction not set') }
})

LoginViewStore.subscribe(s => s.inputValue, (value) => {
    const isMemberId = Number(value) > 0;
    const isEmail = value.includes('@');
    // console.log('[LoginViewStore.subscribe]', {value, isMemberId, isEmail});
    LoginViewStore.update(s => {
        s.loginMethod = isMemberId ? 'member' : isEmail ? 'email' : 'member';
        s.email = isEmail ? value : null;
        s.member = isMemberId ? value : null;
        s.nextDisabled = !isMemberId && !isEmail;
    })
});
